import { useEffect, useState } from 'react';
import { Typography } from '../typography';
import { Button } from '../button';
import {
  ModalBase,
  ModalWrapper,
  ModalFooterButtons,
  ModalBodyCustomColumns,
} from './ModalComponents';
import { BelongsToSelects } from '../select';
import { useSetInvoicesPendingMutation } from '../../hooks';
import { i18n } from '../../i18n';
import { useStore } from '../../context';
import { RefreshPageActions } from '../../store';
import { MESSAGES } from '../../const';
import { enqueueSnackbar } from '../snackbar';

export const invoicePendingModal: any = {};

export const InvoicePendingModal = () => {
  const { dispatch } = useStore();
  const { mutate, isLoading } = useSetInvoicesPendingMutation();
  const [open, setOpen] = useState(false);

  const [yardId, setYardId] = useState<string>('');

  useEffect(() => {
    invoicePendingModal.open = () => {
      setOpen(true);
    };
  }, []);

  const handleOnClose = () => {
    setOpen(false);
    Object.keys(invoicePendingModal).forEach((key) => {
      if (key !== 'open') delete invoicePendingModal[key];
    });
  };

  const handleSubmit = async () => {
    mutate(
      { yardId, ids: invoicePendingModal.ids },
      {
        onSuccess: () => {
          handleOnClose();
          enqueueSnackbar(MESSAGES.INVOICE.SUCCESS.PENDING, 'success');
          dispatch({ type: RefreshPageActions.SET_REFRESH_PAGE });
        },
      },
    );
  };

  return (
    <ModalBase id={'invoice-pending-modal'} open={open} onClose={handleOnClose}>
      <ModalWrapper>
        <Typography variant={'textL'} weight={'bold'}>
          {i18n.t('pages.modal.invoicePendingTitle')}
        </Typography>

        {!invoicePendingModal.names?.length && (
          <ModalBodyCustomColumns columns={'1fr'} isSticky>
            <BelongsToSelects
              hidePlaces
              handleYardChange={(obj) => {
                setYardId(obj.id);
              }}
              isSubmitClicked={false}
            />
          </ModalBodyCustomColumns>
        )}

        {!!invoicePendingModal.names?.length && (
          <ModalBodyCustomColumns columns={'1fr'}>
            {invoicePendingModal.names.map((name: string, i: number) => (
              <Typography key={i} variant={'textM'}>
                {name}
              </Typography>
            ))}
          </ModalBodyCustomColumns>
        )}

        <ModalFooterButtons>
          <Button size={'medium'} data-color={'white'} onClick={handleOnClose} disabled={isLoading}>
            {i18n.t('button.cancel')}
          </Button>
          <Button
            size={'medium'}
            onClick={handleSubmit}
            disabled={isLoading || (!yardId && !invoicePendingModal.ids?.length)}
          >
            {i18n.t('button.submit')}
          </Button>
        </ModalFooterButtons>
      </ModalWrapper>
    </ModalBase>
  );
};
